<div class="card mb-3">
  <div class="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
    <h2 class="mb-0">{{compact ? 'Credit Summary' : 'Credit Collection'}}{{consolidated ? ' — Consolidated' : ''}}</h2>
    <div class="d-flex gap-2">
      <a *ngIf="compact" class="btn btn-primary btn-sm" [routerLink]="['/lo', company, 'credit-collection']"
         [queryParams]="consolidated ? {scope: 'consolidated'} : {}">View collection list</a>
      <button class="btn btn-outline-secondary btn-sm" (click)="load()" [disabled]="loading">Refresh</button>
    </div>
  </div>
  <div class="card-body">
    <p class="text-muted">Current outstanding credit, across all dates. Partial payments and wallet deductions reduce the balance; fillbacks re-extend credit.</p>
    <p *ngIf="loading" role="status">Loading credit balances…</p>
    <div *ngIf="error" class="alert alert-danger" role="alert">{{error}}</div>
    <ng-container *ngIf="!loading && !error">
      <p *ngIf="!summary.length" class="mb-0">No outstanding credit to collect.</p>
      <div class="d-flex flex-wrap gap-3">
        <div *ngFor="let total of summary" class="border rounded p-3">
          <strong>{{total.currency === 'none' ? 'Currency not set' : total.currency}}</strong>
          <div>Players to collect: <b>{{total.players | number}}</b></div>
          <div>Outstanding credit: <b>{{total.outstanding | number:'1.2-2'}}</b></div>
        </div>
      </div>
      <ng-container *ngIf="!compact && items.length">
        <div class="d-flex flex-wrap gap-3 my-3">
          <label>Player search<input class="form-control" [(ngModel)]="search" (ngModelChange)="page = 1" placeholder="Code, name or mobile"></label>
          <label *ngIf="consolidated">Company<select class="form-select" [(ngModel)]="companyFilter" (ngModelChange)="page = 1">
            <option value="">All companies</option><option *ngFor="let item of companies" [value]="item.uuid">{{item.name}}</option>
          </select></label>
        </div>
        <p>{{filtered.length}} matching players. Summary above includes all outstanding players.</p>
        <div class="table-responsive">
          <table class="table table-striped table-sm">
            <thead><tr><th *ngIf="consolidated">Company</th><th>Player code</th><th>Name</th><th>Mobile</th><th>Currency</th><th class="text-end">Outstanding</th><th>Last credit activity</th><th></th></tr></thead>
            <tbody><tr *ngFor="let item of visible">
              <td *ngIf="consolidated">{{item.company_name}}</td><td>{{item.player_code}}</td><td>{{item.player_name}}</td><td>{{item.mobile}}</td>
              <td>{{item.currency === 'none' ? 'Not set' : item.currency}}</td><td class="text-end">{{item.outstanding | number:'1.2-2'}}</td>
              <td>{{item.last_on | date:'dd-MM-yyyy HH:mm'}} ({{item.last_type}})</td>
              <td><a class="btn btn-outline-primary btn-sm" [routerLink]="['/lo', item.company_uuid, 'player-credit']" [queryParams]="{player: item.player_uuid}">Open collection</a></td>
            </tr></tbody>
          </table>
        </div>
        <p *ngIf="!filtered.length">No players match your search.</p>
        <div class="d-flex gap-3 align-items-center" *ngIf="filtered.length > pageSize">
          <button class="btn btn-outline-secondary btn-sm" [disabled]="page <= 1" (click)="page = page - 1">Previous</button>
          <span>Page {{page}}</span>
          <button class="btn btn-outline-secondary btn-sm" [disabled]="page * pageSize >= filtered.length" (click)="page = page + 1">Next</button>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
